import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceRemoveTaskStatusState = createStateReducer(initialState, {
  [events.removeTaskStatusSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "removeTaskStatus",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.removeTaskStatusFailed]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "removeTaskStatus",
        flags: ["failure"],
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceRemoveTaskStatusState };
